import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_2 = { class: "inline-flex justify-between" }
const _hoisted_3 = { class: "font-semibold text-16px pr-48 pl-4" }
const _hoisted_4 = { class: "rounded px-2 py-0 bg-gray-lp-400 text-12px xxl:text-14px" }
const _hoisted_5 = { class: "capitalize" }
const _hoisted_6 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_7 = { class: "inline" }
const _hoisted_8 = { class: "text-gray-lp-600 text-12px xxl:text-14px float-left pl-4" }
const _hoisted_9 = { class: "pt-2" }
const _hoisted_10 = { class: "pt-2" }
const _hoisted_11 = { class: "pt-4 text-black-lp-300 font-semibold" }
const _hoisted_12 = { class: "text-gray-lp-600 text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_13 = { class: "pt-2 text-right" }
const _hoisted_14 = { class: "pt-2 text-right" }
const _hoisted_15 = { class: "pt-4 text-right text-black-lp-300 font-semibold" }
const _hoisted_16 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_17 = { class: "inline" }
const _hoisted_18 = { class: "text-gray-lp-600 text-12px xxl:text-14px float-left pl-4" }
const _hoisted_19 = { class: "pt-2" }
const _hoisted_20 = { class: "pt-2" }
const _hoisted_21 = { class: "pt-2" }
const _hoisted_22 = { class: "pt-2" }
const _hoisted_23 = { class: "pt-4 text-black-lp-300 font-semibold" }
const _hoisted_24 = { class: "text-gray-lp-600 text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_25 = { class: "pt-2 text-right" }
const _hoisted_26 = { class: "pt-2 text-right" }
const _hoisted_27 = { class: "pt-2 text-right" }
const _hoisted_28 = { class: "pt-2 text-right" }
const _hoisted_29 = { class: "pt-4 text-right text-black-lp-300 font-semibold" }
const _hoisted_30 = { class: "border-b border-gray-lp-400 py-4 flex-col flex" }
const _hoisted_31 = { class: "inline" }
const _hoisted_32 = { class: "text-black-lp-300 text-12px xxl:text-14px float-left pl-4" }
const _hoisted_33 = { class: "pt-2 flex" }
const _hoisted_34 = { class: "font-semibold" }
const _hoisted_35 = {
  key: 0,
  class: "text-black-lp-200 ml-1"
}
const _hoisted_36 = { class: "rounded px-2 py-0 bg-gray-lp-400 text-12px xxl:text-14px" }
const _hoisted_37 = { class: "capitalize" }
const _hoisted_38 = { class: "text-black-lp-300 text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_39 = { class: "pt-2 text-right font-semibold" }
const _hoisted_40 = {
  key: 0,
  class: "inline"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "text-black-lp-300 text-12px xxl:text-14px float-left pl-4" }, [
  /*#__PURE__*/_createVNode("div", { class: "pt-2 flex" }, [
    /*#__PURE__*/_createVNode("p", { class: "font-semibold" }, "Biaya Admin")
  ])
], -1)
const _hoisted_42 = { class: "text-black-lp-300 text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_43 = { class: "pt-2 text-right font-semibold" }
const _hoisted_44 = {
  key: 0,
  class: "border-b border-gray-lp-400 py-4"
}
const _hoisted_45 = { class: "inline" }
const _hoisted_46 = { class: "text-black-lp-300 text-12px xxl:text-14px float-left pl-4" }
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "pt-2 text-gray-lp-600" }, "COD Amount", -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "pt-2 font-semibold" }, "Biaya COD", -1)
const _hoisted_49 = {
  key: 0,
  class: "pt-2 text-gray-lp-600"
}
const _hoisted_50 = {
  key: 1,
  class: "pt-2 text-gray-lp-600"
}
const _hoisted_51 = { class: "text-black-lp-300 text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_52 = { class: "pt-2 text-right text-gray-lp-600" }
const _hoisted_53 = { class: "pt-2 text-right font-semibold" }
const _hoisted_54 = {
  key: 0,
  class: "pt-2 text-right text-gray-lp-600"
}
const _hoisted_55 = {
  key: 1,
  class: "pt-2 text-right text-gray-lp-600"
}
const _hoisted_56 = {
  key: 1,
  class: "border-b border-gray-lp-400 py-4"
}
const _hoisted_57 = { class: "flex flex-row justify-between" }
const _hoisted_58 = { class: "flex text-gray-lp-300 text-12px xxl:text-14px float-left pl-4" }
const _hoisted_59 = { class: " w-36" }
const _hoisted_60 = { class: "items-center ml-5 mt-0.5" }
const _hoisted_61 = { class: "text-12px" }
const _hoisted_62 = { class: "text-gray-lp-300 text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_63 = { class: "border-b border-gray-lp-400 py-4 rounded" }
const _hoisted_64 = { class: "inline" }
const _hoisted_65 = { class: "text-12px xxl:text-14px float-left pl-4" }
const _hoisted_66 = { class: "pr-4 float-right" }
const _hoisted_67 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_68 = { class: "inline" }
const _hoisted_69 = { class: "text-black-lp-300 text-12px xxl:text-14px float-left pl-4" }
const _hoisted_70 = { class: "text-gray-lp-600" }
const _hoisted_71 = { class: "text-gray-lp-600 text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_72 = { class: "pt-2 text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_ctx.isShow)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: "\n      absolute\n      overflow-y-auto\n      border-l border-r\n      flex flex-col\n      bg-white\n      rounded-bl rounded-br\n      shadow\n    ",
        style: `margin-top: ${_ctx.isDiscountActive ? '100px' : '76px'}; max-height: 75vh`
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('bookingShipment.estimation.title')), 1),
            _createVNode("div", {
              class: 
            `text-black-lp-200 ${_ctx.dataDetail.productType ? 'pr-3' : 'pr-17'}`
          
            }, [
              _createVNode("div", _hoisted_4, [
                _createVNode("span", _hoisted_5, _toDisplayString(_ctx.dataDetail.productType), 1)
              ])
            ], 2)
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('bookingShipment.estimation.cityRate')), 1),
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('bookingShipment.estimation.forwardRate')), 1),
              _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('bookingShipment.estimation.shipmentRates')), 1)
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, _toDisplayString(_ctx.currency(_ctx.dataDetail.cityRates)), 1),
              _createVNode("div", _hoisted_14, _toDisplayString(_ctx.currency(_ctx.dataDetail.forwardRates)), 1),
              _createVNode("div", _hoisted_15, _toDisplayString(_ctx.currency(_ctx.dataDetail.shippingCost)), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('bookingShipment.estimation.commoditySurcharge')), 1),
              _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('bookingShipment.estimation.weightAdditionalCharge')), 1),
              _createVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('bookingShipment.estimation.additionalDocumentCost')), 1),
              _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('bookingShipment.estimation.woodpackingCost')), 1),
              _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('bookingShipment.estimation.additionalCost')), 1)
            ]),
            _createVNode("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, _toDisplayString(_ctx.currency(_ctx.dataDetail.commoditySurcharge)), 1),
              _createVNode("div", _hoisted_26, _toDisplayString(_ctx.currency(_ctx.dataDetail.heavyWeightSurcharge)), 1),
              _createVNode("div", _hoisted_27, _toDisplayString(_ctx.currency(_ctx.dataDetail.documentSurcharge)), 1),
              _createVNode("div", _hoisted_28, _toDisplayString(_ctx.currency(_ctx.dataDetail.woodpackingRates)), 1),
              _createVNode("div", _hoisted_29, _toDisplayString(_ctx.currency(_ctx.dataDetail.additionalCost)), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_30, [
          _createVNode("div", _hoisted_31, [
            _createVNode("div", _hoisted_32, [
              _createVNode("div", _hoisted_33, [
                _createVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('bookingShipment.estimation.insurance')), 1),
                (_ctx.dataDetail.insuranceName)
                  ? (_openBlock(), _createBlock("span", _hoisted_35, [
                      _createVNode("span", _hoisted_36, [
                        _createVNode("span", _hoisted_37, _toDisplayString(_ctx.dataDetail.insuranceName?.replace("Insurance", "")), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_38, [
              _createVNode("div", _hoisted_39, _toDisplayString(_ctx.currency(_ctx.dataDetail.insuranceRates - _ctx.dataDetail.insuranceAdminFee)), 1)
            ])
          ]),
          (!_ctx.accountIsForeign)
            ? (_openBlock(), _createBlock("div", _hoisted_40, [
                _hoisted_41,
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, _toDisplayString(_ctx.currency(_ctx.dataDetail.insuranceAdminFee)), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.isForeignCurrency)
          ? (_openBlock(), _createBlock("div", _hoisted_44, [
              _createVNode("div", _hoisted_45, [
                _createVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _hoisted_48,
                  (_ctx.isEnableCodBooking)
                    ? (_openBlock(), _createBlock("div", _hoisted_49, " PAD Fee "))
                    : _createCommentVNode("", true),
                  (_ctx.isCodRetail)
                    ? (_openBlock(), _createBlock("div", _hoisted_50, "Biaya Retur"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_51, [
                  _createVNode("div", _hoisted_52, _toDisplayString(_ctx.currency(_ctx.dataDetail.codAmount)), 1),
                  _createVNode("div", _hoisted_53, _toDisplayString(_ctx.currency(_ctx.dataDetail.codFee)), 1),
                  (_ctx.isEnableCodBooking)
                    ? (_openBlock(), _createBlock("div", _hoisted_54, _toDisplayString(_ctx.currency(_ctx.dataDetail.padFee)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.isCodRetail)
                    ? (_openBlock(), _createBlock("div", _hoisted_55, _toDisplayString(_ctx.currency(_ctx.codReturnFee)), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isDiscountActive && _ctx.dataDetail.discountBoards.length)
          ? (_openBlock(), _createBlock("div", _hoisted_56, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataDetail.discountBoards, (promo, index) => {
                return (_openBlock(), _createBlock("div", {
                  class: "inline",
                  key: index
                }, [
                  _createVNode("div", _hoisted_57, [
                    _createVNode("div", _hoisted_58, [
                      _createVNode("div", _hoisted_59, _toDisplayString(_ctx.startCase(promo.pdcCategory)) + " Promo", 1),
                      _createVNode("div", _hoisted_60, [
                        _createVNode("div", {
                          class: "\n                  flex flex-row\n                  bg-green-lp-700\n                  text-white text-10px\n                  px-1\n                  rounded-md\n                  cursor-pointer\n                ",
                          onMouseenter: ($event: any) => (_ctx.onOpenTooltipPromo($event, index)),
                          onMouseleave: ($event: any) => (_ctx.onOpenTooltipPromo($event, index))
                        }, [
                          _createVNode("p", null, _toDisplayString(promo.pdcPromoDiscount) + "% Off", 1),
                          _createVNode(_component_Icons, {
                            name: "info",
                            class: "w-3 ml-1"
                          })
                        ], 40, ["onMouseenter", "onMouseleave"]),
                        _createVNode(_component_OverlayPanel, {
                          ref: `infoPromo${index}`,
                          appendTo: "body",
                          class: "text-center",
                          style: {"width":"200px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode("p", _hoisted_61, _toDisplayString(promo.pdcName) + " sampai dengan " + _toDisplayString(_ctx.formatDateWithoutTime(promo.pdcEndDate)), 1)
                          ]),
                          _: 2
                        }, 1536)
                      ])
                    ]),
                    _createVNode("div", _hoisted_62, _toDisplayString(_ctx.currency(promo.pdcDiscountAmount)), 1)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_63, [
          _createVNode("div", _hoisted_64, [
            _createVNode("div", _hoisted_65, [
              _createVNode("div", {
                class: `${_ctx.isDiscountActive ? 'pt-5' : 'pt-2'} font-semibold text-black-lp-300`
              }, _toDisplayString(_ctx.$t('bookingShipment.estimation.totalCost')), 3)
            ]),
            _createVNode("div", _hoisted_66, [
              _createVNode("div", {
                class: 
              `pt-2 text-right text-16px ${
                _ctx.isDiscountActive
                  ? 'text-gray-lp-600 line-through'
                  : 'text-red-lp-100 font-bold'
              }`
            
              }, _toDisplayString(_ctx.currency(_ctx.dataDetail.totalTariff)), 3),
              _withDirectives(_createVNode("div", { class: "text-right text-16px text-red-lp-100 font-bold" }, _toDisplayString(_ctx.currency(_ctx.dataDetail.totalTariffAfterDiscount)), 513), [
                [_vShow, _ctx.isDiscountActive]
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_67, [
          _createVNode("div", _hoisted_68, [
            _createVNode("div", _hoisted_69, [
              _createVNode("div", _hoisted_70, _toDisplayString(_ctx.$t('bookingShipment.estimation.taxEstimate')), 1)
            ]),
            _createVNode("div", _hoisted_71, [
              _createVNode("div", _hoisted_72, _toDisplayString(_ctx.currency(_ctx.dataDetail.taxRates)), 1)
            ])
          ])
        ])
      ], 4))
    : _createCommentVNode("", true)
}